<template>
  <div id="form">
    <div>
      <img
        @click="closeModal()"
        src="@/assets/img/icons/close-icon.png"
        alt="close-icon"
        class="icon-close"
      />
      <h1 style="text-align:center;">{{ $t("attendees.import") }}</h1>
      <hr />
      <div>
        <div id="upDownButtonsContainer">
          <div id="upDownButtons">
            <p class="infoText">
              {{ $t("attendees.canvasExplaination") }} :
              <a
                style="font-weight:bold;"
                :href="'../../../static/canvasCSV' + getCsvLanguage()"
                id="canvasButton"
                class="  is-primary"
              >
                {{ $t("attendees.getCanvas") }}
              </a>
            </p>
            <br />
            <b-upload
              v-model="file"
              v-on:input="handleFileUpload"
              class="draggableupload"
              drag-drop
            >
              <a id="inputBuefy" class="draggableupload is-primary">
                <b-icon
                  pack="fas"
                  icon="folder-open"
                  size="is-small"
                  id="folderIcon"
                ></b-icon>
                <span id="labelFileUploader ">{{
                  file ? file.name : $t("attendees.search")
                }}</span>
              </a>
            </b-upload>
          </div>
        </div>
        <div align="center">
          <b-button
            style="min-width:150px;"
            :loading="loader"
            :disabled="file === null || file === undefined"
            class=" is-primary senderUpload"
            v-on:click="submitFile()"
            >{{ $t("attendees.importButton") }}</b-button
          >
        </div>
      </div>
    </div>
    <!-- Add one attendee "by hand" -->
    <div class="addAttendee">
      <p id="titreSolo" style="font-size:16px;">
        {{ $t("attendees.selfAdding") }}
      </p>
      <hr />

      <b-field grouped>
        <form id="addAttendee" @submit.prevent="handleSingleUpload">
          <b-field :label="$t('attendees.firstName') + '*'" expanded>
            <b-input id="firstname" v-model="firstName"></b-input>
          </b-field>

          <b-field
            :label="$t('attendees.lastName') + '*'"
            id="lastName"
            expanded
          >
            <b-input id="lastname" v-model="lastName"></b-input>
          </b-field>

          <b-field
            :label="$t('attendees.email') + '*'"
            expanded
            id="email"
            :type="validEmail === false ? 'is-danger' : ''"
          >
            <b-input id="email" v-model="email" @input="validate"></b-input>
          </b-field>

          <b-field class="labelInput" :label="$t('attendees.company')">
            <input type="text" id="company" class="input" v-model="company"
          /></b-field>
          <div align="center" style="margin-top:20px;">
            <button
              style="width:150px;"
              :disabled="
                (!validEmail && email !== '') ||
                  lastName === '' ||
                  firstName === ''
              "
              class="button is-primary mt-2"
              type="is-success"
            >
              {{ $t("attendees.add") }}
            </button>
          </div>
        </form>
      </b-field>
    </div>
    <p class="mb-2" >{{ $t("popup.required") }}</p>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      email: "",
      lastName: "",
      firstName: "",
      company: "",
      validEmail: undefined,
      file: undefined,
      loader: false
    };
  },
  props: ["eventId"],
  methods: {
    closeModal() {
      this.$parent.close();
    },
    validate() {
      var regEmail = /^[A-Za-z0-9._-]+@[a-z0-9._-]+\.[a-z]{2,20}(\;[A-Za-z0-9._-]+@[a-z0-9._-]+\.[a-z]{2,20}){0,20}$/;

      if (
        regEmail.test(String(this.email).toLowerCase()) ||
        this.edited.email === ""
      ) {
        this.validEmail = true;
      } else {
        this.validEmail = false;
      }
    },
    getPdfLanguage() {
      let pdf = "";
      this.$store.state.langage.langue === "fr"
        ? (pdf = "TermeEtConditions.pdf")
        : (pdf = "TermsAndConditions.pdf");
      return pdf;
    },
    getCsvLanguage() {
      let csv = "";
      this.$store.state.langage.langue === "fr"
        ? (csv = "/Gabarit.csv")
        : (csv = "/Template.csv");
      return csv;
    },
    handleFileUpload() {
      this.$buefy.toast.open({
        type: "is-success",
        message: this.$i18n.t("toast.fileSent")
      });
    },
    handleSingleUpload(e) {
      if (this.firstName !== "" && this.lastName !== "") {
        let data = {
          first_name: this.firstName,
          last_name: this.lastName,
          email: this.email,
          company: this.company,
          event_id: this.eventId,
          accepts_terms_conditions: null
        };
        e.srcElement[0].focus();
        axios
          .post(`${process.env.URL_SSO_API}shortcut/attendees`, data, {
            headers: {
              "Content-Type": "application/json"
            }
          })
          .then(() => {
            this.$buefy.toast.open({
              type: "is-success",
              message: this.$parent.$i18n.t("toast.uploadSuccess")
            });
          })

          .catch(
            function(err) {
              if (
                typeof err.response.data === "object" &&
                err.response.data !== null
              ) {
                this.$parent.close();

                let error = this.$parent.$i18n.t("attendees.duplicateMail");
                this.$buefy.toast.open({
                  type: "is-danger",
                  message: error
                });
              } else {
                this.$parent.close();

                this.$buefy.toast.open({
                  type: "is-danger",
                  message: err.response.data
                });
              }

              this.$parent.close();
            }.bind(this)
          );
        this.$parent.close();
      } else {
        this.$buefy.toast.open({
          type: "is-danger",
          message: this.$i18n.t("toast.emptyInput")
        });
      }
      this.$parent.close();
    },
    submitFile() {
      if (this.file) {
        let formData = new FormData();
        formData.append("csv", this.file, "attendees.csv");
        formData.append("event_id", this.eventId);
        if (
          (formData.get("csv").type === "text/csv" ||
            formData.get("csv").type === "application/vnd.ms-excel") &&
          formData.get("csv").size > 2
        ) {
          this.loader = true;
          axios
            .post(`${process.env.URL_SSO_API}shortcut/attendeesCsv`, formData)
            .then(res => {
              this.loader = false;

              this.$parent.close();
              this.$buefy.toast.open({
                type: "is-success",
                message: this.$parent.$i18n.t("toast.uploadSuccess")
              });
            })
            .catch(err => {
              this.loader = false;

              if (
                typeof err.response.data === "object" &&
                err.response.data !== null
              ) {
                let mail = "";
                mail = err.response.data.message.split(" ")[7];
                this.$buefy.toast.open({
                  type: "is-danger",
                  message:
                    this.$i18n.t("attendees.duplicateMail") +
                    " " +
                    mail.slice(1, mail.length - 3)
                });
              } else {
                let newString = err.response.data.split(";");

                this.$emit("errorMessage", newString);
              }

              this.$parent.close();
            });
        } else if (formData.get("file").type === "text/csv") {
          this.$buefy.toast.open({
            type: "is-danger",
            message: this.$i18n.t("toast.emptyFile")
          });
        } else {
          this.$buefy.toast.open({
            type: "is-danger",
            message: this.$i18n.t("toast.wrongFile")
          });
        }
      } else {
        this.$buefy.toast.open({
          type: "is-danger",
          message: this.$i18n.t("toast.noFile")
        });
      }
    }
  }
};
</script>

<style scoped>
#form {
  padding: 10px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  min-width: 200px;
  min-height: 200px;
  background-color: white;
}
.icon-close {
  width: 20px;
  height: 20px;
  cursor: pointer;
  float: right;
}

#fillItAll {
  font-size: 0.8em;
}

.draggableupload {
  width: 100%;
  text-align: center;
  height: 75px;
  margin: auto;
  display: block;
}

.infoText {
  font-size: 0.9em;
  text-align: center;
}

.emailInput {
  top: calc(20% + 3vh);
}

.upload-draggable {
  width: 100%;
  text-align: center;
  height: 75px;
}

#fileUploader {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

#fileUploader + label {
  cursor: pointer; /* "hand" cursor */
}

#fileUploader:focus + label {
  outline: 1px dotted #000;
  outline: -webkit-focus-ring-color auto 5px;
}

#titreSolo {
  height: 2em;
  width: 100%;
  display: block;
  white-space: nowrap;
  margin-top: 10px;
  text-align: center;
}

#labelFileUploader {
  display: block;
  margin-right: auto;
  margin-bottom: 30px;
  width: 50%;
  z-index: 10;
}

h1 {
  font-size: 16px;
}

.addAttendee {
  padding: 20px;
  min-width: 300px;
}

.senderUpload {
  /* width: 100%; */
  margin-top: 30px;
}

#addAttendee {
  max-width: none;
  width: 100%;
}

#folderIcon {
  margin-left: 10px;
}

#tableAttendees {
  margin-bottom: 100px;
}

.fileUploader {
  justify-content: space-evenly;
  flex-wrap: wrap;
}

#canvasDownload {
  width: 100%;
}

.upload {
  margin-top: 10px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/popupCreateAdmin.vue